<div class="flex h-full flex-col">
  <div class="bg-m0 flex flex-grow overflow-y-auto rounded shadow">
    <div class="ml-5 mr-5 mt-6 flex w-full flex-col">
      <div class="flex h-11 flex-row items-center">
        <m-search-icon class="text-s1 ml-8"></m-search-icon>

        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="modelsSearchInput"
          class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[400px] rounded"
          placeholder="Search Models by Label or FileName"
          [ngClass]="{
            'bg-p200': !!word
          }"
          [(ngModel)]="word"
          (ngModelChange)="searchWordChange()"
        />

        <div class="h-9 w-9">
          <m-delete-icon
            *ngIf="!!word"
            class="text-s1 ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
            [ngClass]="{
              'bg-p200 hover:bg-p300 cursor-pointer': !!word
            }"
            (click)="resetSearch()"
          ></m-delete-icon>
        </div>

        <div class="flex-grow"></div>
      </div>

      <div class="divide-s500 mt-10 flex flex-col divide-y">
        <div
          class="text-s1 mb-3 mr-5 flex flex-row space-x-5 text-base font-semibold"
        >
          <div class="flex w-12"></div>
          <div class="flex w-1/4">Model</div>
          <div class="flex flex-1 flex-row space-x-5">
            <div class="flex flex-1"> Model Id</div>
            <div class="flex flex-1">Space</div>
            <div class="flex flex-1">Access Roles</div>
            <div class="flex flex-1">Connection</div>
          </div>
        </div>
        <div class="flex w-full flex-row"></div>
      </div>

      <div
        class="h-2 flex-1 overflow-y-auto"
        *ngIf="filteredModels?.length > 0"
      >
        <div
          *ngFor="let item of filteredModels; let i = index; trackBy: trackByFn"
          class="bg-m0 hover:bg-m50 flex flex-row hover:cursor-pointer"
          [ngStyle]="
            item.modelId !==
              filteredModels[filteredModels.length - 1].modelId && {
              'border-bottom-width': '1px'
            }
          "
          [ngClass]="{
            'mt-2': i === 0,
            'mb-5': i === filteredModels.length - 1,
            'border-s300':
              item.modelId !== filteredModels[filteredModels.length - 1].modelId
          }"
        >
          <div class="flex-grow flex-col text-base">
            <div
              class="text-s1 group mr-5 flex w-full flex-row items-start space-x-5 rounded pt-1 focus:outline-none"
              (click)="navigateToModel(item)"
            >
              <div class="flex w-12 pl-3">
                <button
                  data-cy="modelOptionsMenuButton"
                  class="hover:bg-m200 invisible flex h-9 w-9 items-center justify-center rounded focus:outline-none group-hover:visible"
                  #t1="tippy"
                  [tp]="templateModelOptions"
                  [tpHideOnEscape]="true"
                  tpVariation="menu"
                  className="my-menu"
                  (click)="rowMenuOnClick($event)"
                >
                  <m-dots-vertical-icon></m-dots-vertical-icon>
                </button>

                <ng-template #templateModelOptions>
                  <div
                    class="border-s4 bg-m0 w-64 rounded-md border-2 shadow-xl"
                  >
                    <button
                      data-cy="modelOptionsGoToFile"
                      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                      (click)="t1.hide(); goToFile($event, item)"
                      >Go to File</button
                    >
                  </div>
                </ng-template>
              </div>

              <ng-template #templateModelsModel>
                <div *ngIf="isExplorer === false">Explorer role required</div>
                <div *ngIf="isExplorer === true">No access to model</div>
              </ng-template>

              <div
                class="flex w-1/4 select-none flex-row pb-[9px] pt-[7px]"
                [tp]="templateModelsModel"
                [tpIsEnabled]="item.hasAccess === false"
              >
                <span
                  class="truncate"
                  [ngClass]="{
                    'text-m600 select-none font-semibold':
                      item.modelId === modelId
                  }"
                >
                  {{ item.label || item.modelId | capitalize }}
                </span>
              </div>

              <div class="flex flex-1 flex-row space-x-5 text-base">
                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span class="truncate">
                    {{ item.modelId }}
                  </span>
                </div>

                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span class="truncate">
                    {{ item.spaceFullTitle }}
                  </span>
                </div>

                <div
                  class="flex flex-1 flex-wrap truncate pb-[9px] pt-[7px] text-base"
                >
                  <span
                    *ngFor="let accessRole of item.accessRolesCombined"
                    class="mr-2 truncate rounded px-2"
                    [ngClass]="{
                      'bg-green-200 text-green-700': accessRole.isDirect,
                      'bg-slate-200 text-slate-700': !accessRole.isDirect
                    }"
                  >
                    {{ accessRole.role }}
                  </span>
                </div>

                <div class="flex flex-1 items-start truncate pb-[9px] pt-[7px]">
                  <span class="truncate">
                    {{ item.connectionId }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="h-11"></div>
        </div>
      </div>

      <div
        class="h-2 flex-1 overflow-y-auto"
        *ngIf="filteredModels?.length === 0"
        ><div
          class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
          >No models</div
        >
      </div>
    </div>
  </div>
</div>

<div *ngIf="model$ | async"></div>
<div *ngIf="models$ | async"></div>
<div *ngIf="isExplorer$ | async"></div>
